import { IContentsApi } from '../api/contents-api';
import { IContentsApi as IApi, ILegacyContentsApi } from '../api/legacy-api';
export { IContentsApi };

const raiseWarning = (label: string) => async () => {
	console.warn(`${label}: not yet availale`);
};

const notImplemented = (label: string) => async () => {
	console.warn(`${label}: not implemented`);
};

/**
 * コンテンツAPI提供用クラスのデフォルト実装
 */
export class DefaultContentApiImpl implements IApi {
	/**
	 * Window実装をデフォルトオブジェクトに戻す
	 */
	public static unsetWindowApi() {
		window.contentsApi = defaultImpl;
	}

	private available: boolean;

	private exitHandler: () => Promise<void>;
	private nextHandler: () => Promise<void>;
	private previousHandler: () => Promise<void>;
	private toggleIndexHandler: () => Promise<void>;

	private legacyObject: ILegacyContentsApi;

	constructor(
		available: boolean,
		exitHandler: () => Promise<void>,
		nextHandler: () => Promise<void>,
		previousHandler: () => Promise<void>,
		toggleIndexHandler: () => Promise<void>
	) {
		this.available = available;
		this.exitHandler = exitHandler;
		this.nextHandler = nextHandler;
		this.previousHandler = previousHandler;
		this.toggleIndexHandler = toggleIndexHandler;

		this.legacyObject = {
			goCrseMenu() {
				return toggleIndexHandler();
			},
			goNext() {
				return nextHandler();
			},

			hideHF: notImplemented('hideHF'),
			showHF: notImplemented('showHF'),

			setBookMark: notImplemented('setBookMark'),

			hideHFbtn: notImplemented('hideHFbtn'),
			showHFbtn: notImplemented('showHFbtn'),

			hideNV: notImplemented('hideNV'),
			showNV: notImplemented('showNV'),

			goMenu() {
				return exitHandler();
			},
			goNextMenu() {
				return exitHandler();
			},
		};
	}

	public isAvailable() {
		return this.available;
	}

	public exit() {
		return this.exitHandler();
	}
	public next() {
		return this.nextHandler();
	}
	public previous() {
		return this.previousHandler();
	}
	public toggleIndex() {
		return this.toggleIndexHandler();
	}

	public get legacy(): ILegacyContentsApi {
		return this.legacyObject;
	}

	/**
	 * このオブジェクトをWindowに設定する
	 */
	public setWindowsApi(): IContentsApi {
		return (window.contentsApi = this);
	}
}

/**
 * 中身の実装されていないデフォルトオブジェクト
 */
const defaultImpl: IApi = new DefaultContentApiImpl(
	false,
	raiseWarning('exit'),
	raiseWarning('next'),
	raiseWarning('previous'),
	raiseWarning('toggleIndex')
);

// 初期状態でデフォルトオブジェクトを設定しておく
DefaultContentApiImpl.unsetWindowApi();



// WEBPACK FOOTER //
// ./src/logic/contents/impl/contents-api-impl.ts